var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Atb",
    clipPath: "url(#clip0_342:15843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7066 0H3.32746C1.49043 0 0 1.48789 0 3.3218V16.6782C0 18.5121 1.49043 20 3.32746 20H16.672C18.509 20 19.9994 18.5121 19.9994 16.6782V3.3218C20.0341 1.48789 18.5437 0 16.7066 0ZM18.9943 16.3322C18.9596 16.3668 18.8903 16.4014 18.8556 16.3668C16.2907 14.8097 13.2405 13.9101 10.0171 13.9101C6.79355 13.9101 3.74339 14.8097 1.17848 16.3668C1.14382 16.4014 1.07449 16.3668 1.03983 16.3322C1.00517 16.263 1.03983 16.2284 1.07449 16.1938C3.43144 14.3945 5.4418 12.1108 7.00155 9.41175C8.56125 6.7128 9.5318 3.80623 9.91305 0.899655C9.91305 0.86505 9.9477 0.79585 10.0171 0.79585C10.0864 0.79585 10.121 0.83045 10.121 0.899655C10.5023 3.80623 11.4728 6.7128 13.0326 9.41175C14.5923 12.1108 16.6373 14.3945 18.9596 16.1592C19.0289 16.2284 19.0289 16.263 18.9943 16.3322Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_342:15843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtb);
export default __webpack_public_path__ + "static/media/atb.3cb4cebbd4bfbb0f5b49a36f63566e0d.svg";
export { ForwardRef as ReactComponent };